<template>
  <b-modal
    id="logoutConfirmModal"
    v-model="internalVisible"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    content-class="lcm-content"
    dialog-class="lcm-dialog"
    body-class="p-0"
  >
    <!-- Close button — ✕ on both mobile and desktop -->
    <button class="lcm-close-btn" @click="onNo" :disabled="isLoading">✕</button>

    <!-- Body -->
    <div class="lcm-body">
      <p class="lcm-text">Are you sure you want to logout?</p>
    </div>

    <!-- Divider -->
    <div class="lcm-divider"></div>

    <!-- Footer buttons -->
    <div class="lcm-footer">
      <button class="lcm-btn-yes" @click="onYes" :disabled="isLoading">
        <span v-show="!isLoading">Yes</span>
        <Loader v-if="isLoading" class="loader-pos-new" />
      </button>
      <button class="lcm-btn-no" @click="onNo" :disabled="isLoading">No</button>
    </div>
  </b-modal>
</template>

<script>
import Loader from '@/components/fixedcomponents/Loader.vue';
export default {
  name: "LogoutConfirmModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components:{Loader},
  data(){
    return{
      isLoading:false,
    }
  },
  computed: {
    internalVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        if (!val) this.$emit("cancel");
      },
    },
  },
  methods: {
    onYes() {
     this.isLoading = true;
        this.$emit("confirm"); 
    },
    onNo() {
      this.$emit("cancel");
    },
  },
};
</script>

<style>
/* ── z-index: outer lifts everything above header/nav/drawer;
   inside that context, modal (z:2) sits above backdrop (z:1) ── */
#logoutConfirmModal___BV_modal_outer_ {
  z-index: 10100 !important;
}
#logoutConfirmModal {
  z-index: 2 !important;
}
#logoutConfirmModal___BV_modal_backdrop_ {
  z-index: 1 !important;
  top: 0 !important;
  height: 100vh !important;
}

/* ── Dialog width ── */
#logoutConfirmModal .lcm-dialog {
  max-width: 487px;
}

/* ── Modal content card ── */
#logoutConfirmModal .lcm-content {
  border: 0.98px solid #e0e0e0 !important;
  border-radius: 24px !important;
  overflow: visible !important; /* allow close btn to sit outside */
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.12) !important;
}

/* ── Close button — ✕ circle, outside top-right on desktop ── */
.lcm-close-btn {
  position: absolute;
  top: -1px;
  right: -48px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  border: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #666;
  cursor: pointer;
  transition: transform 0.2s ease, color 0.2s ease;
  z-index: 10;
}

.lcm-close-btn:hover,
.lcm-close-btn:active {
  transform: scale(1.1);
  color: #2e425d;
}

.lcm-close-btn:disabled {
  cursor: not-allowed;
  transform: none;
}

/* ── Body ── */
.lcm-body {
  padding: 29px 29px 23px 29px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lcm-text {
  font-family: "Inter", sans-serif;
  font-size: 24.53px;
  font-weight: 600;
  color: #2e425d;
  text-align: center;
  margin: 0;
  line-height: 1;
  letter-spacing: 0;
}

/* ── Divider ── */
.lcm-divider {
  height: 1px;
  background:#ECECEC;
  margin: 0 19.63px;
}

/* ── Footer buttons ── */
.lcm-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24.53px 19.63px;
  gap: 16px;
}

.lcm-btn-yes,
.lcm-btn-no {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 52px;
  border-radius: 116px;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 13.93px 18.58px;
}

.lcm-btn-yes {
  background: #20639b;
  color: #ffffff;
  border: none;
}

.lcm-btn-yes:hover {
  background: #174f7a;
}

/* Loader overlay — spinner origin is at (0,0), so top/left 50% centers it */
.lcm-btn-yes .loader-pos-new {
  position: absolute;
  top: 50%;
}

.lcm-btn-no {
  background: #ffffff;
  color: #20639b;
  border: 1.5px solid #20639b;
}

.lcm-btn-no:hover {
  background: #f0f7ff;
}

.lcm-btn-yes:disabled,
.lcm-btn-no:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ── Mobile ── */
@media screen and (max-width: 1028px) {
  /* Dialog container */
  #logoutConfirmModal .lcm-dialog {
    max-width: 397px;
    width: calc(100vw - 32px);
    margin-left: auto;
    margin-right: auto;
  }

  /* Card */
  #logoutConfirmModal .lcm-content {
    border: 0.8px solid #e0e0e0 !important;
    border-radius: 24px !important;
  }

  /* Body — top padding 24px, reduce horizontal to fit text in one line */
  .lcm-body {
    padding: 24px 20px 19.12px 20px;
  }

  /* Text — 18px fits single line on 375px phones */
  .lcm-text {
    font-size: 18px;
    white-space: nowrap;
  }

  /* Divider — show on mobile with same inset as footer padding */
  .lcm-divider {
    display: block;
    margin: 0 16px;
  }

  /* Footer — no border-top (divider element handles it), padding 20px 16px */
  .lcm-footer {
    border-top: none;
    padding: 20px 16px;
    gap: 12px;
  }

  /* Buttons — 40px height, fully pill-shaped */
  .lcm-btn-yes,
  .lcm-btn-no {
    height: 40px;
    border-radius: 95px;
    font-size: 14px;
    padding: 11.36px 15.14px;
  }

  /* Close button — hidden on mobile */
  .lcm-close-btn {
    display: none;
  }
}
</style>
